export default __webpack_public_path__ + "images/aa251123c307bc2185460d0bd911b041.svg";